<template>
  <el-dialog title="提示" :visible="true" width="95%" :before-close="close">
    <div slot="title" style="text-align: center">
      <span class="fz18 fw500" style="font-weight: bolder">发票详情</span>
    </div>
    <el-row :gutter="10">
      <div class="app-detail-item-title pb16" style="width:100%">
        发票邮寄信息
      </div>
      <el-col
        class="mb16 app-form-item"
        :xs="12"
        :sm="12"
        :md="12"
        :lg="8"
        :xl="8"
      >
        <div class="app-form-label">收件人：</div>
        <el-input
          class="app-form-input"
          size="small"
          :value="tableRespond.receiptFullName"
          disabled
        ></el-input>
      </el-col>
      <el-col
        class="mb16 app-form-item"
        :xs="12"
        :sm="12"
        :md="12"
        :lg="8"
        :xl="8"
      >
        <div class="app-form-label">联系方式：</div>
        <el-input
          class="app-form-input"
          size="small"
          :value="tableRespond.receiptPhone"
          disabled
        ></el-input>
      </el-col>
      <el-col
        class="mb16 app-form-item"
        :xs="12"
        :sm="12"
        :md="12"
        :lg="8"
        :xl="8"
      >
        <div class="app-form-label">发票邮寄地址：</div>
        <el-input
          class="app-form-input"
          size="small"
          :value="tableRespond.receiptAddress"
          disabled
        ></el-input>
      </el-col>
      <el-col
        class="mb16 app-form-item"
        :xs="12"
        :sm="12"
        :md="12"
        :lg="8"
        :xl="8"
      >
        <div class="app-form-label">收件地址名称：</div>
        <el-input
          class="app-form-input"
          size="small"
          :value="tableRespond.addressName"
          disabled
        ></el-input>
      </el-col>
      <el-col
        class="mb16 app-form-item"
        :xs="12"
        :sm="12"
        :md="12"
        :lg="8"
        :xl="8"
      >
        <div class="app-form-label">电子邮箱：</div>
        <el-input
          class="app-form-input"
          size="small"
          :value="tableRespond.email"
          disabled
        ></el-input>
      </el-col>
    </el-row>
    <div class="app-detail-item-title pb16" style="width:100%">
      开票内容
    </div>
    <el-col
      class="mb16 app-form-item"
      :xs="12"
      :sm="12"
      :md="12"
      :lg="8"
      :xl="8"
    >
      <div class="app-form-label">发票价税合计：</div>
      <div class="app-form-input el-input el-input--small is-disabled">
        <div class="el-input__inner">
          {{ tableRespond.invoiceAmount | money }} 元
        </div>
      </div>
      <div
        v-if="tableRespond.invoiceMethod || tableRespond.invoiceMethod === 0"
        class="app-form-label"
      >
        开票方式：
      </div>
      <div
        v-if="tableRespond.invoiceMethod || tableRespond.invoiceMethod === 0"
        class="app-form-input el-input el-input--small is-disabled"
      >
        <div class="el-input__inner">
          {{ tableRespond.invoiceMethod ? '电子发票' : '纸质发票' }}
        </div>
      </div>
    </el-col>
    <div class="app-detail-item-title pb16" style="width:100%">
      物流信息
    </div>
    <div
      class="mb16 app-form-item el-col el-col-24 el-col-xs-12 el-col-sm-12 el-col-md-12 el-col-lg-8 el-col-xl-8"
    >
      <div class="app-form-label">发票邮寄方式：</div>
      <div v-if="tableRespond.isMail == null">
        <el-radio disabled value="9" label="9">非邮寄</el-radio>
      </div>
    </div>

    <div class="app-detail-item-title pb16" style="width:100%">
      发票详情
      <small>（开票人数{{ tableRespond.theNumberOfMakeOutAnInvoice }}）</small>
    </div>
    <div class="tableContain" ref="tableContain"></div>
    <!--    <table-render ref="tableRender" :config="config" :propData="{query:query}" />-->
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="close">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { detail } from '@/page/bill/child/detail-of-commission.config';
import createExtend from '@C/createExtend';
import tableRender from '@C/tableRender';

export default {
  name: 'DetailOfCommission',
  props: {
    row: {
      type: [Object],
      // 为了方便修改 都列出
      default: () => ({
        authDt: '', //null
        createDt: '', //"2021-03-18 10:23:53"
        enterpriseName: '', //null
        id: '', //2214
        invoiceAmount: '', //8
        invoiceBusinessType: '', //2
        invoiceOrderNo: '', //"1372373157276680192"
        invoiceStatus: '', //0
        itemId: '', //null
        itemName: '', //null
        noPassReason: '' //null
      })
    }
  },
  data() {
    return {
      tableRespond: {}
    };
  },
  computed: {
    query() {
      const { id, invoiceBusinessType } = this.row;
      return { id, invoiceBusinessType };
    }
  },
  methods: {
    close() {
      this.remove();
    }
  },
  mounted() {
    const { id, invoiceBusinessType } = this.row;
    this.$nextTick(() => {
      const table = createExtend(
        tableRender,
        {
          config: detail(),
          propData: {
            query: { id, invoiceBusinessType }
          }
        },
        this.$refs['tableContain']
      );
      table.$on('respondFinished', res => {
        this.tableRespond = res.responseInvoiceCsoSupplier;
      });
    });
  }
};
</script>

<style scoped>
.tableContain {
  width: 100%;
  min-height: 100px;
}

.app-form-item {
  display: inline-flex;
  align-items: center;
  text-align: left;
  /*flex-wrap: wrap;*/
}

.app-form-label {
  display: inline-block;
  min-width: 130px;
  text-align: right;
  margin-right: 8px;
}

.app-form-input {
  flex: 1;
}
</style>
